/*=========================================================================================
File Name: actions.js
Description: Vuex Store - actions
----------------------------------------------------------------------------------------
Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
Author: Pixinvent
Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from "vue";

const actions = {


	// /////////////////////////////////////////////
	// COMPONENTS
	// /////////////////////////////////////////////

	// Vertical NavMenu
	updateVerticalNavMenuWidth({ commit }, width) {
		commit('UPDATE_VERTICAL_NAV_MENU_WIDTH', width)
	},

	// VxAutoSuggest
	updateStarredPage({ commit }, payload) {
		commit('UPDATE_STARRED_PAGE', payload)
	},

	// The Navbar
	arrangeStarredPagesLimited({ commit }, list) {
		commit('ARRANGE_STARRED_PAGES_LIMITED', list)
	},
	arrangeStarredPagesMore({ commit }, list) {
		commit('ARRANGE_STARRED_PAGES_MORE', list)
	},


	// /////////////////////////////////////////////
	// UI
	// /////////////////////////////////////////////

	toggleContentOverlay({ commit }) {
		commit('TOGGLE_CONTENT_OVERLAY')
	},
	updateTheme({ commit }, val) {
		commit('UPDATE_THEME', val)
	},

	// /////////////////////////////////////////////
	// User/Account
	// /////////////////////////////////////////////

	updateUserInfo({ commit }, payload) {
		commit('UPDATE_USER_INFO', payload)
	},


	// ////////////////////////////////////////////
	// CUSTOM
	// ////////////////////////////////////////////

	// Takedown Domains
	setTakedownDomains: ({ commit }, domains) => {
		commit('setTakedownDomains', domains)
	},
	clearTakedownDomains: ({ commit }) => {
		commit('clearTakedownDomains')
	},

	// Listing Count
	setListingTotalCount: ({ commit }, count) => {
		commit('setListingTotalCount', count)
	},
	setListingFilteredCount: ({ commit }, count) => {
		commit('setListingFilteredCount', count)
	},
	clearListingCount: ({ commit }) => {
		commit('clearListingCount')
	},

	// CNIC Promo Filter
	setPromoFilter: ({ commit }, filter) => {
		commit('SET_PROMO_FILTER', filter)
	},
	clearPromoFilter: ({ commit }) => {
		commit('CLEAR_PROMO_FILTER')
	},

	// Table Filter
	setTableFilterValue: ({ commit }, value) => {
		commit('setTableFilterValue', value)
	},
	clearTableFilterValue: ({ commit }) => {
		commit('clearTableFilterValue')
	},
	setTableFilterOptions: ({ commit }, options) => {
		commit('setTableFilterOptions', options)
	},
	clearTableFilterOptions: ({ commit }) => {
		commit('clearTableFilterOptions')
	},
	setTableFilterActive: ({ commit }) => {
		commit('setTableFilterActive')
	},
	clearTableFilterActive: ({ commit }) => {
		commit('clearTableFilterActive')
	},

	// Blacklisted Keywords
	setBlacklistedKeywords: ({ commit }, value) => {
		commit('setBlacklistedKeywords', value)
	},
	clearBlacklistedKeywords: ({ commit }) => {
		commit('clearBlacklistedKeywords')
	},

	// Switch to tab on Promo Lists
	setSwitchToTab({ commit }, value) {
		commit('setSwitchToTab', value);
	},

	// Master Data Actions
	setUsers: ({ commit }) => {
		return Vue.prototype.$axiosSecure.get('/users')
			.then((response) => {
				commit('setUsers', response.data);
			})
	},
	setAMs: ({ commit }) => {
		return Vue.prototype.$axiosSecure.get('/users/ams')
			.then((response) => {
				commit('setAMs', response.data);
			})
	},
	setRoles: ({ commit }) => {
		return Vue.prototype.$axiosSecure.get('/roles')
			.then((response) => {
				commit('setRoles', response.data);
			})
	},
	setCountries: ({ commit }) => {
		return Vue.prototype.$axiosSecure.get('/countries')
			.then((response) => {
				commit('setCountries', response.data);
			})
	},
	setCurrencies: ({ commit }) => {
		return Vue.prototype.$axiosSecure.get('/currencies')
			.then((response) => {
				commit('setCurrencies', response.data);
			})
	},
	setTlds: ({ commit }) => {
		return Vue.prototype.$axiosSecure.get('/tlds')
			.then((response) => {
				commit('setTlds', response.data);
			})
	},
	setRegistrars: ({ commit }) => {
		return new Promise((resolve, reject) => {
			Vue.prototype.$axiosSecure.get('/v2/unique-registrars')
				.then((response) => {
					commit('setRegistrars', response.data);
					resolve(response.data);
				})
				.catch(err => {
					reject(err);
				})
		})
	},
	setCustomUniqueRegistrars: ({ commit }) => {
		return new Promise((resolve, reject) => {
			Vue.prototype.$axiosSecure.get('/v2/unique-registrars/custom')
				.then((response) => {
					commit('setCustomUniqueRegistrars', response.data);
					resolve(response.data);
				})
				.catch(err => {
					reject(err);
				})
		})
	},
	setResellers: ({ commit }) => {
		return Vue.prototype.$axiosSecure.get('/v2/resellers')
			.then((response) => {
				commit('setResellers', response.data);
			})
	},
	setGroups: ({ commit }) => {
		return Vue.prototype.$axiosSecure.get('/groups')
			.then((response) => {
				commit('setGroups', response.data);
			})
	},
	setPromoTags: ({ commit }) => {
		return Vue.prototype.$axiosSecure.get('/promo-tags')
			.then((response) => {
				commit('setPromoTags', response.data);
			})
	},
	setCustomTags: ({ commit }) => {
		return Vue.prototype.$axiosSecure.get('/custom-tags')
			.then((response) => {
				commit('setCustomTags', response.data);
			})
	},
	setClientOptions: ({ commit }, registrars) => {
		let clientsList = registrars;
		var transformedClientsList = [];

		for (var client of clientsList) {
			var temp = {
				id: // NOTE: CNIC-<Registrar ID>-<Country ID>-<Client Name>
					"CNIC-" +
					client["id"] +
					"-" +
					client["country_id"] +
					"-" +
					client["name"],
				label: client["name"],
				isDisabled: JSON.parse(localStorage.getItem("userDetails")).role == "user" ? !((client["unique_registrar_client_am"] && client["unique_registrar_client_am"].length && client["unique_registrar_client_am"][0]["user_id"]) === JSON.parse(localStorage.getItem("userDetails")).id) : false,
				children: client["new_reseller"].length ? [] : undefined,
				new_registrar: client.new_registrar.map(x => { return { value: x.id, label: client.name, cnic_id: x.cnic_id, unique_registrar_id: client["id"] }})
			};

			if (client["new_reseller"].length) {
				for (var reseller of client["new_reseller"]) {
					temp["children"].push({
						id: // NOTE: PROMO-<Reseller ID>-<Registrar ID>-SAME-<Country ID>-<Reseller Name>
							reseller["name"] === client["name"]
								? "PROMO-" +
								reseller["id"] +
								"-" +
								client["id"] +
								"-" +
								"SAME-" +
								client["country_id"] +
								"-" +
								reseller["name"]
								: "PROMO-" +
								reseller["id"] +
								"-" +
								client["id"] +
								"-" +
								reseller["name"],
							label: reseller["name"],
							isDisabled: JSON.parse(localStorage.getItem("userDetails")).role == "user" ? !((reseller["new_reseller_client_am"] && reseller["new_reseller_client_am"].length && reseller["new_reseller_client_am"][0]["user_id"]) === JSON.parse(localStorage.getItem("userDetails")).id) : false,
							new_registrar: reseller["name"] === client["name"] ? client.new_registrar.map(x => { return { value: x.id, label: client.name, cnic_id: x.cnic_id, unique_registrar_id: client["id"] }}) : []
					});
				}
			}

			transformedClientsList.push(temp);
		}

		return commit('setClientOptions', transformedClientsList);
	},
	// TODO: set client options Tucows
	setTucowsOnboardingRegistrars: ({ commit }, tucowsOnboardingRegistrars) => {
		return Vue.prototype.$axiosSecure.get('/tucows/onboarding-registrars')
		.then((response) => {
			commit('setTucowsOnboardingRegistrars', response.data);
		})
	},

	// Rebates Partner View
	setClientRebateStatus({ commit }, val) {
		commit('setClientRebateStatus', val);
	},
	setClientToken({ commit }, val) {
		commit('setClientToken', val);
	},
	setClientAMName({ commit }, val) {
		commit('setClientAMName', val);
	},
	setClientAMEmail({ commit }, val) {
		commit('setClientAMEmail', val);
	},

	setDisableCNICFlag({ commit }, val) {
		commit('setDisableCNICFlag', val);
	}
}

export default actions
